import React, { useState } from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import { Link } from '@ta-interaktiv/contentbricks'


function Slide(props: any)
{
  let style = props.style ? props.style : {}
  style.zIndex = props.settings.active === props.id ? 100 : (props.settings.old === props.id ? 90 : 10)
  style.opacity = 1
  return (
    <div className={`${props.settings.active === props.id ? "fadeIn" : ""} slide ${props.className ? props.className : ''}`} style={style}>
      {props.children}
    </div>
  )
}

export function Litzmannstadt() {

  const [slideSettings, setActiveSlide] = useState({active: 'c0', old: ''})

  const waypointtrigger = (e: any, prop: string) => {
    setActiveSlide({active: prop, old: slideSettings.active})
  }

  const focusPointGhetto = '47% 48%';

  return (
    <div className='litzmannstadt'>

      <div className='sticky'>

      <Slide settings={slideSettings} id='c0' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/0.jpg')})`,
            backgroundPosition: "77% 31%"
          }} />

        <Slide settings={slideSettings} id='c1' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/1.jpg')})`,
            backgroundPosition: "77% 90%"
          }} />

        <Slide settings={slideSettings} id='c2' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/2.jpg')})`,
            backgroundPosition: "45% 29%"
          }} />

        <Slide settings={slideSettings} id='c3' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/3.jpg')})`,
            backgroundPosition: focusPointGhetto
          }}
        />   
          
        <Slide settings={slideSettings} id='c4' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/4.jpg')})`,
            backgroundPosition: focusPointGhetto
          }}
        />
        <Slide settings={slideSettings} id='c4b' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/4b.jpg')})`,
            backgroundPosition: '57% 0%'
          }}
        />
            
        <Slide settings={slideSettings} id='c5' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/5.jpg')})`,
            backgroundPosition: "58% 51%"
          }}
        />
          
        <Slide settings={slideSettings} id='c6' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/6.jpg')})`,
            backgroundPosition: "47% 73%"
          }}
        />

        <Slide settings={slideSettings} id='c7' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/7.jpg')})`,
            backgroundPosition: focusPointGhetto
          }}
        />

        <Slide settings={slideSettings} id='c8' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/hamburg/8.jpg')})`,
            backgroundPosition: focusPointGhetto
          }}
        />

        { /* ---- Ghetto ---- */}

        <Slide settings={slideSettings} id='ghetto0' 
          className='backgroundimage'
          style={{
            backgroundImage: `url(${require('./images/ghetto/0.jpg')})`,
            backgroundPosition: "77% 31%"
          }} />

          <Slide settings={slideSettings} id='ghetto1' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/1.jpg')})`,
              backgroundPosition: "58% 28%"
            }} />


          <Slide settings={slideSettings} id='ghetto2' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/2.jpg')})`,
              backgroundPosition: "34% 72%"
            }}
          />   
            
          <Slide settings={slideSettings} id='ghetto3' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/3.jpg')})`,
              backgroundPosition: focusPointGhetto
            }}
          />

          <Slide settings={slideSettings} id='ghetto4' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/4.jpg')})`,
              backgroundPosition: "66% 37%"
            }}
          />

          <Slide settings={slideSettings} id='ghetto5' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/5.jpg')})`,
              backgroundPosition: focusPointGhetto
            }}
          />

          <Slide settings={slideSettings} id='ghetto6' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/6.jpg')})`,
              backgroundPosition: focusPointGhetto
            }}
          />          

          <Slide settings={slideSettings} id='ghetto7' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/7.jpg')})`,
              backgroundPosition: "32% 40%"
            }}
          />     

          <Slide settings={slideSettings} id='ghetto8' 
            className='backgroundimage'
            style={{
              backgroundImage: `url(${require('./images/ghetto/8.jpg')})`,
              backgroundPosition: focusPointGhetto
            }}
          />

      </div>
      
      <div className='ui text container '>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c0')} >  
          <div className='ui raised segment chapter' style={{marginTop: '-50vh'}}>
            <h4>Vom Grindelquartier ins Ghetto</h4>
            Der letzte Weg des Ehepaars Stemmer durch Hamburg
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'c1')} >  
          <div className='ui raised segment chapter'>
            <p>
              Der Brief kam per Post an die Heider-Strasse 22. Wahrscheinlich Mitte Oktober 1941. Überschrift Evakuierungsbefehl. Wahrscheinlich wussten Lea und Moritz Stemmer nicht genau, was sie erwartet. Zumal sie zum allerersten Deportationszug aus Hamburg gehörten. Dies legt die Aussage einer Frau nahe, die damals die Abreisenden mit Lebensmitteln versorgte. Sie erzählt in einer Videoaufnahme, die im Infopavillon bei der Gedenkstätte Hannoverscher Bahnhof zu sehen ist, dass bei den ersten Deportationen noch ungewiss war, dass diese Reise für die meisten in den baldigen Tod führt.
            </p>
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'c2')}>  
          <div className='ui raised segment chapter'>
            <p>
              Lea und Moritz Stemmer haben ihren letzten Weg durch Hamburg wahrscheinlich zu Fuss unternommen. Vielleicht sind sie zuerst die paar Schritte zum Eppendorfer-Baum gegangen, wo Leas Schwester Etel Bernstein mit ihrem Mann Nathan wohnte. Die beiden haben sie begleitet. Weiter ging es vorbei am Innocentiaplatz, wo sie jeweils den Gottesdienst besuchten. Die Gebäude sind von den Bomben verschont geblieben. Die ehemalige Synagoge fällt durch ihre Rundbogenfenster auf, ist nun aber ein Privathaus. Später wurden hier jüdische Menschen auf engstem Raum untergebracht. Sie waren zuvor aus ihren Wohnungen vertrieben worden, um «Ariern» Platz zu machen.
            </p>
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'c3')}>  
          <div className='ui raised segment chapter'>
            <p>
              Weiter ging es wohl über die Brahmsallee. Auch das ist heute eine ruhige Strasse. Manche Häuser aus der Gründerzeit stehen noch. Vor fast allen Eingängen sind Stolpersteine eingelassen. Ungutes geahnt haben die Stemmers bestimmt, als sie hier entlanggingen, mussten sie doch in den Jahren zuvor erfahren, wie sie immer mehr entrechtet und erniedrigt und systematisch aus dem öffentlichen Leben verdrängt wurden. Einfach nur, weil sie jüdisch waren.
            </p>
            <p>
            Am 1. April 1933 riefen SA-Männer in vielen Städten (hier Berlin) zum Boykott jüdischer Geschäfte auf.
            </p>
            {/* <p className='credit'>Foto: Georg Pahl (Bundesarchiv Deutschland)</p> */}
          </div>
        </Waypoint> 

        <Waypoint onEnter={e => waypointtrigger(e, 'c4')}>  
          <div className='ui raised segment chapter'>
            <p>
              Dann kamen sie an der 1911 gebauten und 1939 geräumten Talmud-Tora-Schule vorbei zum Bornplatz. Hier stand einst die grosse Synagoge. Am 9./10. November 1938 war sie verwüstet, im Jahr darauf abgerissen worden. Die Schule ist seit 2007 wieder im Besitz der jüdischen Gemeinde.
            </p>
            {/* <p className='credit'>Foto: PD</p> */}
          </div>
        </Waypoint>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c4b')}>  
          <div className='ui raised segment chapter'>
            <p>
              Im Pflaster des stillen leeren Platzes sind durch schwarze Granitsteine die Linien des Deckengewölbes der ehemaligen Synagoge abgebildet. Im November 2020 gab der Bundestag 65 Millionen Euro für die Rekonstruktion der Synagoge frei. Derselbe Betrag soll die Stadt Hamburg beisteuern.
            </p>
          </div>
        </Waypoint>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c5')}>  
          <div className='ui raised segment chapter'>
            <p>
              Angekommen in der Moorweidenstrasse. Das Haus der Freimaurer ist riesig. Davor stehen in einem etwas trostlosen Rasenspickel ein Mahnmal und eine unscheinbare Tafel. Die Aufschrift: Platz der Jüdischen Deportierten. Hier kamen die Stemmers am Vortag ihrer Deportation an. Man nahm ihnen das Letzte ab, was sie noch hatten. Mitnehmen durften sie:  ein bis zu 50 kg schwerer Koffer, Bettzeug, Verpflegung für drei Tage,100 Reichsmark. 
            </p>
          </div>
        </Waypoint>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c6')}>  
          <div className='ui raised segment chapter'>
            <p>
              Am nächsten Tag wurden sie zum Hannoverschen Bahnhof gebracht. Abfahrt: um 10.10 Uhr, Eintreffen in Łódź am Folgetag um 11 Uhr. Die oben erwähnte Zeitzeugin spricht von einer gespenstischen Atmosphäre, von einem ewig langen Zug, von an Ketten aufgehängten Beleuchtungskörpern, die im Wind hin und her schwangen und dabei quietschten. 
            </p>
          </div>
        </Waypoint>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c7')}>  
          <div className='ui raised segment chapter'>
            <p>
              Der Bahnhof existiert heute nicht mehr. Erhalten geblieben sind nur der Bahnsteig 2 und drei Geleise, die ins Leere führen. An seiner Stelle liegt heute der Lohseplatz in der Hafencity. Seit 2017 entsteht dort eine Gedenkstätte.
            </p>
          </div>
        </Waypoint>
        
        <Waypoint onEnter={e => waypointtrigger(e, 'c8')}>  
          <div className='ui raised segment chapter'>
            <p>
              Auf einer Tafel stehen die Namen der Deportierten. Am 25. Oktober 1941 bestiegen 1033 jüdische Männer und Frauen zusammen mit Lea und Moritz Stemmer den ewig langen Zug. 1020 verloren wenig später ihr Leben aufgrund der Strapazen oder im Vernichtungslager Kulmhof (Chełmno).
            </p>
          </div>
        </Waypoint>

        {/* --- GHETTO --- */}


        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto0')} >  
          <div className='ui raised segment chapter'>
            <h4>Eingepfercht auf 4km<sup>2</sup></h4>
            Das erwartete die Stemmers im Ghetto Litzmannstadt.
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto1')}>  
          <div className='ui raised segment chapter'>
            <p>
              Nach Warschau lebten in keiner europäischen Stadt mehr Juden als in Łódź. Als Joseph Goebbels die mittlerweile in Litzmannstadt umbenannte polnische Stadt besuchte, notierte er in sein Tagebuch: «Es ist unbeschreiblich. Das sind keine Menschen mehr, das sind Tiere. Das ist deshalb auch keine humanitäre, sondern eine chirurgische Aufgabe. Man muss hier Schnitte tun, und zwar ganz radikale. [...] Warum nur muss dieser Dreckhaufen eine deutsche Stadt werden!»
            </p>
            <p>
              Wenige Monate nach Goebbels Besuch, im Februar 1940, beginnt die Umsiedlung der Juden.
            </p>
            {/* <p className='credit'>Foto: Keystone/PHOTOPRESS-ARCHIV/Str</p> */}
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto2')}>  
          <div className='ui raised segment chapter'>
            <p>
              Das Armenviertel von Łódź wird zum Ghetto umfunktioniert. 4,3 km<sup>2</sup> steht den Bewohnerinnen und Bewohnern anfänglich zur Verfügung. Von Anfang an war das Ghetto als Zwischenlager geplant, damit am Ende «das Ghetto und damit die Stadt Lodsch von Juden gesäubert» werden könne, wie es offiziell heisst. Nach und nach werden auch Juden aus anderen Gegenden – etwa aus Hamburg wie die Stemmers – nach Litzmannstadt deportiert. 
            </p>
          </div>
        </Waypoint> 

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto3')}>  
          <div className='ui raised segment chapter'>
            <p>
              160’320 Menschen lebten 1940 auf der Fläche der Zürcher Innenstadt, unter prekären hygienischen Bedingungen. Offiziell verwaltete sich das Ghetto selbst, die Nazis setzten einen ihnen gefügigen «Judenrat» ein.
            </p>
          </div>
        </Waypoint> 

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto4')}>  
          <div className='ui raised segment chapter'>
            <p>
              Chaim Rumkowski wird von den Nazis zum «Judenältesten» und damit zum offiziellen Verwalter des Ghettos ernannt. Er will das Überleben der Deportierten sichern, indem er das Ghetto unentbehrlich für die Deutschen macht: nämlich als günstige Produktionsfabrik für allerlei Waren. «Unser einziger Weg ist Arbeit», heisst seine Parole.
            </p>
            {/* <p className='credit'>Foto: ushmm.gov</p> */}
          </div>
        </Waypoint>   

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto5')}>  
          <div className='ui raised segment chapter'>
            <p>
              Das funktioniert nur bedingt, Ende 1941 erhält der Judenrat den Auftrag, 20’000 Bewohner für den Abtransport ins Vernichtungslager auszuwählen. Weitere Säuberungswellen folgen. 10’000 Juden im Januar 1942, 34’000 im Februar, 11’000 im Mai. Von Januar bis Mai 1942 werden 57’064 Juden und fast 4300 Romas ins Vernichtungslager abtransportiert. Niemand von diesen überlebt. 
            </p>
          </div>
        </Waypoint>  
        
        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto6')}>  
          <div className='ui raised segment chapter'>
            <p>
              Im September 1942 beginnen die blutigen Wochen, die als «Allgemeine Gehsperre» bekannt werden sollen. 20’000 Juden sollten weg. Rumkowski verhängt eine Ausgangssperre, niemand darf das Haus verlassen. Jüdische Polizisten unter Aufsicht der Besatzer durchsuchen Haus für Haus. Alte, Kranke und Kinder unter 10 Jahren werden abtransportiert. «Skrupellos, ohne Gnade, nahmen sie sie ihren Familien und zogen Babys aus den Armen der Mütter. Nach einigen Tagen war das Ghetto um ein Drittel kleiner», erinnert sich Leon Weintraub, einer der wenigen Überlebenden gegenüber der Deutschen Welle.
            </p>
          </div>
        </Waypoint>

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto7')}>  
          <div className='ui raised segment chapter'>
            <p>
              1944 schliesslich ordnet Heinrich Himmler die Liquidation des Ghettos an. 77’000 Menschen leben zu diesem Zeitpunkt noch dort. Im August beginnen die Transporte nach Auschwitz-Birkenau. Bis Ende Monat werden rund 70’000 Menschen ins Vernichtungslager abtransportiert. Am 28. August verlässt der letzte Zug das Ghetto Litzmannstadt. Mit dabei: der «Judenälteste» Chaim Rumkowski. Er wird höchstwahrscheinlich noch am gleichen Tag umgebracht.
            </p>
          </div>
        </Waypoint>        

        <Waypoint onEnter={e => waypointtrigger(e, 'ghetto8')}>  
          <div className='ui raised segment chapter' style={{marginBottom: '100vh'}}>
            <p>
              Am 19. Januar 1945 wird eine neue Flagge gehisst: Sowjetische Soldaten marschieren in die Stadt ein. Von den einst 160’320 Menschen im Ghetto sind noch deren 850 dort. Es sind jene, die für die letzten Aufräumarbeiten zurückgelassen wurden oder sich verstecken konnten. Die Naziherrschaft überstanden haben auch Tausende Fotos, welche das Leben im Ghetto dokumentieren.
            </p>
            <p className='credit'>
              Fotos Naziaushang: Georg Pahl (Bundesarchiv Deutschland)<br />
              Fotos Litzmannstadt: Staatsarchiv Łódź<br />
              Foto Chaim Rumkowski: ushmm.gov<br />
              Foto Goebbels: Keystone/PHOTOPRESS-ARCHIV/Str
            </p>
          </div>
        </Waypoint>        
     
             

      </div>
    </div>
  )
}
